/// <amd-module name="SuiteCommerce.PagePrinter.ItemDetailsLayout"/>
define("SuiteCommerce.PagePrinter.ItemDetailsLayout", ["require", "exports", "SuiteCommerce.PagePrinter.ItemDetailsLayout.ItemDetailsLayout.View"], function (require, exports, ItemDetailsLayout_View_1) {
    "use strict";
    return {
        mountToApp: function (container) {
            var pageTypeComponent = container.getComponent('PageType');
            pageTypeComponent.registerPageType({
                name: 'ext-page-printer-item-details',
                routes: ['print-item-details/:item(/)'],
                view: ItemDetailsLayout_View_1.ItemDetailsLayoutView,
                defaultTemplate: {
                    name: 'sc-pageprinter-item-details-default.tpl',
                    displayName: 'Default Page printer',
                    thumbnail: '',
                },
            });
        },
    };
});
